import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { forgotPassword } from '../actions/api';
import AuthLayout, { apiErrorMessage } from './AuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err));
    }
    setBusy(false);
  };

  return (
    <AuthLayout>
      {sent ? (
        <div>
          <h2>Check your email</h2>
          <p className="lede">
            If an account uses <b>{email}</b>, a reset link is on its way. The link works for one hour.
          </p>
          <div className="auth-links"><Link to="/">Back to log in</Link></div>
        </div>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <h2>Reset your password</h2>
          <p className="lede">Enter your email and we’ll send you a link to set a new password.</p>
          {error && <div className="form-error" role="alert">{error}</div>}
          <TextField label="Email" type="email" autoComplete="email" value={email} required autoFocus
            onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" variant="contained" size="large" fullWidth disabled={busy || !email.includes('@')}>
            {busy ? 'Sending…' : 'Send reset link'}
          </Button>
          <div className="auth-links"><Link to="/">Back to log in</Link></div>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
